import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { DetalleTurnoFinalizadoContent } from "./components/DetalleTurnoFinalizadoContent";
// la tabla de padres PT y su estilo viven en la page del cierre de turno
import "../CierreTurno/styles/Producciones.css";

class DetalleTurnoFinalizado extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        const { match } = this.props;
        const turnoId = match.params.id;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción"
                    subtitulo="Detalle de turno finalizado"
                    noBorder
                >
                    <DetalleTurnoFinalizadoContent
                        turnoId={turnoId}
                        regresar={this.regresar}
                    />
                </Card>
            </div>
        );
    }
}

export default DetalleTurnoFinalizado;
